import styled from 'styled-components';
import React from 'react';
import YourExperience from './1-YourExperience'
import YourResponses from './2-YourResponses'
import YourAnonymity from './3-YourAnonymity'
import YourAttestation from './4-YourAttestation'

const SurveyIntro = ({ id, title }) => {
  const renderIntro = (screen_id) => {
    switch (screen_id) {
      case 1:
        return <YourExperience title={title} />;
      case 2:
        return <YourResponses />;
      case 3:
        return <YourAnonymity />;
      case 4:
        return <YourAttestation />;
      default:
        return <YourExperience />;
    }
  }

  return (
    <IntroductionContainer>
      {renderIntro(id)}
    </IntroductionContainer>
  );
};


export default SurveyIntro;

const IntroductionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width:600px;
`;
